import { formatInTimeZone } from "date-fns-tz";

export type TimeOfDay = "morning" | "afternoon" | "evening";

export type GroupedSlots = Record<TimeOfDay, string[]>;

const AFTERNOON_START_HOUR = 12;
const EVENING_START_HOUR = 17;

export const groupSlotsByTimeOfDay = (
  slots: string[],
  timezone: string,
): GroupedSlots => {
  const grouped: GroupedSlots = {
    morning: [],
    afternoon: [],
    evening: [],
  };

  const sorted = slots.slice().sort();

  for (const slot of sorted) {
    const hour = Number(formatInTimeZone(new Date(slot), timezone, "H"));

    if (hour < AFTERNOON_START_HOUR) {
      grouped.morning.push(slot);
    } else if (hour < EVENING_START_HOUR) {
      grouped.afternoon.push(slot);
    } else {
      grouped.evening.push(slot);
    }
  }

  return grouped;
};
